import { render } from "./ActionIcon.vue?vue&type=template&id=7f9fa546&scoped=true"
import script from "./ActionIcon.vue?vue&type=script&lang=js"
export * from "./ActionIcon.vue?vue&type=script&lang=js"

import "./ActionIcon.vue?vue&type=style&index=0&id=7f9fa546&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9fa546"]])

export default __exports__